import React, { useState } from 'react';

import { Switch, Slider, SliderText } from './styles';
import PropTypes from 'prop-types';

const ToggleSwitch = (props) => {
  return (
    <Switch>
      <input type='checkbox' id={props.id} onChange={props.changeState} />
      <Slider filterType={props.filterType}>
        <SliderText>{props.filterType === 'List' ? 'Grid' : 'List'}</SliderText>
      </Slider>
    </Switch>
  );
};
ToggleSwitch.propTypes = {
  filterType: PropTypes.string,
  changeState: PropTypes.func,
};
export default ToggleSwitch;
